export default (...validators) =>
  (value) => {
    const validator = validators.find((v) => !!v(value));
    if (validator) return validator(value);

    return undefined;
  };
